<script>
    import Carousel from "svelte-carousel";
    import DialogFilter from "../modals/DialogFilter.svelte";

    let filterModal = false;
</script>

<div class="container">
    <div class="row">
        <div class="col-lg-8">
            <div class="carousel">
                <Carousel
                        particlesToShow={1}
                        particlesToScroll={1}
                        let:showPrevPage
                        let:showNextPage
                        autoplay={true}
                        autoplayDuration={5000}
                >
                    <div class="item">
                        <div class="item-inner item-heureka" style="background-image: url('/assets/img/carousel/carousel-1.webp')">
                            <div class="heureka-badge">
                                <div id="showHeurekaBadgeHere-2"></div>
                            </div>
                            <h1>Overený e-shop <span>spokojnosťou zákazníkov</span></h1>
                            <p>Vďaka desiatkám overených recenzií od našich zákazníkov vám vieme zaručiť férovosť nášho e-shopu.</p>
                            <a class="btn btn-outline-white" href="https://obchody.heureka.sk/pneuin-sk/recenze/" target="_blank" rel="noopener"><i class="fas fa-fw fa-comment-dots mr-2"></i>Prezrieť recenzie</a>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-inner" style="background-image: url('/assets/img/carousel/carousel-2.webp')">
                            <h1>Doručenie do 48 hodín <span>u vybraných dodávateľov</span></h1>
                            <p>U vybraných dodávateľov a skladov vám vašu objednávku vybavíme a doručíme do 48 hodín.</p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-inner" style="background-image: url('/assets/img/carousel/carousel-3.webp')">
                            <h1>Viac než 35 000 pneumatík<span>priamo k vašim dverám</span></h1>
                            <p>Máme jeden z najväčších výberov pneumatík na Slovensku, a to všetko vieme doručiť do pár dní až k vašim dverám.</p>
                            <button type="button" on:click={() => { filterModal = true; }} class="btn btn-outline-white"><i class="fas fa-fw fa-tire mr-2"></i>Vyhľadať pneumatiku</button>
                        </div>
                    </div>
                    <!--<div class="item">
                        <div class="item-inner" style="background-image: url('/assets/img/carousel/carousel-4.webp')">
                            <h1>Potrebujete prezuť?<span>Žiaden problém!</span></h1>
                            <p>Ste z okolia Košíc a nechcete sa obťažovať s vybavovaním servisu, ktorý vám prezuje? Urobíme to za vás! Jednoducho si objednajte pneumatiky na našu pobočku a prihoďte si do košíka prezutie a my vás budeme kontaktovať!</p>
                        </div>
                    </div>-->

                    <div slot="prev" on:click={showPrevPage} class="custom-arrow custom-arrow-prev">
                        <i class="fal fa-fw fa-arrow-left-long"></i>
                    </div>
                    <div slot="next" on:click={showNextPage} class="custom-arrow custom-arrow-next">
                        <i class="fal fa-fw fa-arrow-right-long"></i>
                    </div>
                </Carousel>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="slider-cards">
                <div on:click={() => { filterModal = true; }} class="card">
                    <div class="card-body">
                        <h5><i class="fas fa-fw fa-filter-list"></i>Filter pneumatík</h5>
                        <p>Ak si potrebujete vyfiltrovať pneumatiky podľa veľkosti či značky, kliknite sem.</p>
                    </div>
                    <i class="fat fa-fw fa-arrow-right-long"></i>
                </div>
                <a class="card" href="#/kontakt">
                    <div class="card-body">
                        <h5><i class="fas fa-fw fa-comments-question"></i>Kontakt</h5>
                        <p>K dospizícii sme Vám každý pracovný deň medzi 8:00 - 16:00 na telefóne alebo e-maile.</p>
                        <ul class="d-lg-none d-xxl-flex">
                            <li><a href="tel:+421911022525">+421 911 022 525</a></li>
                            <li><a href="mailto:info@pneuin.sk">info@pneuin.sk</a></li>
                        </ul>
                    </div>
                    <i class="fat fa-fw fa-arrow-right-long"></i>
                </a>
            </div>
        </div>
    </div>
</div>

{#if filterModal}
    <DialogFilter bind:open={filterModal} />
{/if}

<style>
    :global(.carousel .sc-carousel__content-container) {
        height: 24rem;
        margin-bottom: 1rem;
        border: 5px solid #E2E8F0;
        border-radius: 1.5rem;
        overflow: hidden;
    }
    :global(.carousel .sc-carousel-dots__container) {
        gap: .5rem !important;
    }
    :global(.carousel .sc-carousel-dots__dot-container) {
        width: fit-content !important;
    }
    :global(.carousel .sc-carousel-dot__dot) {
        background-color: var(--color-slate-300) !important;
        width: .6rem !important;
        height: .6rem !important;
        border-radius: 50% !important;
        outline: none !important;
    }
    :global(.carousel .sc-carousel-dot__dot_active) {
        background-color: #E65025 !important;
        width: 2rem !important;
        border-radius: .5rem !important;
        opacity: 1 !important;
    }
    :global(.carousel .custom-arrow) {
        position: absolute;
        border: 1px solid rgba(255, 255, 255, .4);
        background-color: rgba(0, 0, 0, .2);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        color: white;
        border-radius: 50%;
        height: 3rem;
        width: 3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: .1s linear;
        cursor: pointer;
        z-index: 150;
    }
    :global(.carousel .custom-arrow:hover) {
        border-color: rgba(255, 255, 255, .6);
    }
    :global(.carousel .custom-arrow.custom-arrow-prev) {
        left: -3rem;
        top: 10.5rem;
    }
    :global(.carousel .custom-arrow.custom-arrow-next) {
        right: -3rem;
        top: 10.5rem;
    }
    :global(.carousel .sc-carousel__content-container:hover .custom-arrow.custom-arrow-prev) {
        left: 1rem;
    }
    :global(.carousel .sc-carousel__content-container:hover .custom-arrow.custom-arrow-next) {
        right: 1rem;
    }
    .carousel .item .item-inner {
        background-size: cover;
        background-position: center;
        height: 24rem;
        padding: 4.5rem;
        position: relative;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: end;
        user-select: none;
    }
    .carousel .item .item-heureka {
        padding: 3rem 3rem 3rem 4.5rem;
    }
    .carousel .item .item-inner::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(264.86deg, rgba(15, 23, 42, 0.5) 0%, rgba(15, 23, 42, 0.95) 100%);
        z-index: 100;
    }
    .carousel .item .item-inner::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.1335) 49.5%, rgba(0, 0, 0, 0.3) 100%);
        opacity: 0;
        transition: .1s linear;
    }
    :global(.carousel .sc-carousel__content-container:hover .item .item-inner::after) {
        opacity: 1;
    }
    .carousel .item .item-inner * {
        z-index: 150;
    }
    .carousel .item .heureka-badge {
        margin-bottom: 1rem;
        border-radius: 50%;
        width: 5rem;
        height: 5rem;
        min-height: 5rem;
        background-color: #e6c32d;
    }
    :global(.carousel .item .heureka-badge img) {
        width: 5rem;
        height: 5rem;
    }
    :global(.carousel .item .heureka-badge:has(img)) {
        background-color: transparent !important;
    }
    .carousel .item h1 {
        font-size: 2.5rem;
        margin-bottom: .5rem;
        font-family: Rubik, sans-serif;
        font-weight: 400;
        color: white;
    }
    .carousel .item .item-heureka h1 {
        font-size: 1.5rem;
    }
    .carousel .item h1 span {
        color: var(--color-secondary);
        display: block;
    }
    .carousel .item p {
        color: rgba(255, 255, 255, .7);
        font-size: 1rem;
        width: 30rem;
        max-width: 100%;
        line-height: 1.4rem;
    }
    .carousel .item .btn {
        margin-top: 1.5rem;
    }
    .slider-cards {
        display: flex;
        flex-direction: column;
        gap: 2rem;
    }
    .slider-cards .card {
        height: 11rem;
        padding: 1rem;
        border-radius: 1.5rem;
        border: 1px solid var(--color-slate-200);
        background-color: var(--color-slate-50);
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        transition: .1s linear;
        cursor: pointer;
    }
    .slider-cards .card:hover {
        border: 1px solid var(--color-slate-400);
    }
    .slider-cards .card .card-body {
        display: flex;
        flex-direction: column;
        flex: none;
        height: fit-content;
    }
    .slider-cards .card h5 {
        font-size: 1.25rem;
        font-family: Rubik, sans-serif;
        font-weight: 600;
        color: var(--color-slate-900);
        margin-bottom: .75rem;
    }
    .slider-cards .card h5 i {
        margin-right: .5rem;
    }
    .slider-cards .card p {
        font-size: 1rem;
        width: 75%;
        max-width: 100%;
        color: var(--color-slate-500);
    }
    .slider-cards .card i.fa-arrow-right-long {
        position: absolute;
        top: 4rem;
        right: 1.5rem;
        transition: .1s linear;
        font-size: 3rem;
        color: var(--color-slate-200);
    }
    .slider-cards .card:hover i.fa-arrow-right-long {
        right: 1rem;
    }
    .slider-cards .card ul {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        list-style-type: none;
        padding-left: 0;
        margin-top: .5rem;
    }
    .slider-cards .card ul li {
        background-color: var(--color-slate-100);
        padding: .5rem;
        border-radius: .5rem;
        width: fit-content;
    }
    .slider-cards .card ul li a {
        color: var(--color-slate-500);
        transition: .1s linear;
    }
    .slider-cards .card ul li a:hover {
        color: var(--color-slate-700);
    }
    @media (max-width: 1399.98px) {
        .slider-cards .card ul {
            flex-direction: column;
            margin-top: .75rem;
        }
    }
    @media (max-width: 991.98px) {
        .slider-cards {
            gap: 1rem;
            margin-top: 2rem;
        }
        .slider-cards .card ul {
            flex-direction: row;
        }
    }
    @media (max-width: 767.98px) {
        .carousel .item .item-inner {
            padding: 2.5rem;
        }
        .carousel .item h1 {
            font-size: 1.5rem;
        }
        .carousel .item .item-heureka h1 {
            font-size: 1.15rem;
        }
        .slider-cards .card ul {
            display: none;
        }
    }
</style>